import type React from 'react';

import { EditIcon } from '@vlabs/icons';
import { Tooltip } from '@vlabs/uikit';
import type { IconButtonProps } from '@vlabs/uikit/components/controls/button/icon-button';
import { IconButton } from '@vlabs/uikit/components/controls/button/icon-button';
// ponytail: осознанный импорт роутов приложения — компонент используется только в point3 (GUI-3947)
import { routes } from '@vlapps/point3/src/app/routes';
import { generatePath, Link } from 'react-router-dom';

import { useGoToEditStreamTranslation } from '../i18n';
import type { GoToEditStreamProps } from '../types';

function GoToEditStreamIconButton({
  streamId,
  ...props
}: GoToEditStreamProps & IconButtonProps): React.JSX.Element {
  const { t } = useGoToEditStreamTranslation();

  return (
    <Tooltip tooltipContent={t('title')}>
      <IconButton
        as={Link}
        data-testid="goToEditStreamButton"
        icon={<EditIcon />}
        kind="secondary"
        to={generatePath(routes.sources.streamView, { streamId })}
        variant="flat"
        {...props}
      />
    </Tooltip>
  );
}

export { GoToEditStreamIconButton };
